import React from 'react';
import styled from 'styled-components';

import badgeWarning from '@/assets/common/badge_warning.svg';

const CUSTOMER_SERVICE_TEL = '02-6275-8011';

function LoginLockedNotice() {
  return (
    <Wrapper>
      <BadgeIcon src={badgeWarning} alt='' />
      <TextArea>
        <Title>로그인 5회 실패로 로그인이 제한되었습니다.</Title>
        <Description>
          해제는 KTP 고객센터 <Tel>{CUSTOMER_SERVICE_TEL}</Tel>로
          <br />
          문의해 주세요.
        </Description>
      </TextArea>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
  padding: 10px 12px 10px 16px;
  border-radius: 8px;
  background-color: #f4f4f4;
`;

const BadgeIcon = styled.img`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
  word-break: keep-all;
`;

const Title = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.28px;
  color: #030303;
`;

const Description = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.24px;
  color: #666666;
`;

const Tel = styled.span`
  font-weight: 600;
`;

export default LoginLockedNotice;
